// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

// Env vars separam o ambiente (dev branch vs main); fallback mantém o comportamento
// atual (produção) em qualquer build/preview onde VITE_SUPABASE_* não esteja setada.
export const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL || "https://api.traderisk360.tech";
const SUPABASE_PUBLISHABLE_KEY = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY || "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imh3dGpzbmVlY2xhcHhldG5nZGpmIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjUwNTA3NTksImV4cCI6MjA4MDYyNjc1OX0.O_7jNUwDVAK_qBd1--j2PBA-vkVcaZpmmANWS8hozbg";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  },
  global: {
    fetch: async (url, options) => {
      const response = await fetch(url, options);

      // Intercept 401 (expired token) from edge functions and API
      // Only redirect when on protected routes — public pages (LP, blog, etc.) should not trigger redirect
      if (response.status === 401) {
        const path = window.location.pathname;
        const isProtectedRoute = path.startsWith('/app') || path.startsWith('/admin') || path.startsWith('/partner');
        if (isProtectedRoute) {
          const { data: { session } } = await supabase.auth.getSession();
          if (!session) {
            console.warn('[SESSION] Token expired, redirecting to login');
            await supabase.auth.signOut();
            window.location.href = '/login?expired=true';
          }
        }
      }

      return response;
    },
  },
});
